import { useBranchStore } from '@/store/branchStore';
import { MapPin } from 'lucide-react';
import { CartButton } from './cart/CartButton';

interface HeaderProps {
  showSearchInHeader?: boolean;
}

export function Header({ showSearchInHeader = false }: HeaderProps) {
  const getBranchName = useBranchStore(s => s.getBranchName);
  const branchInfo = useBranchStore(s => s.branchInfo);

  const pharmacyName = getBranchName();

  const address = [branchInfo?.address, branchInfo?.lga, branchInfo?.state]
    .filter(Boolean)
    .join(', ');
  const mapsUrl = address
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        address
      )}`
    : '';

  return (
    <div className="sticky top-0 bg-white z-50">
      <div className="container mx-auto w-full bg-white px-6 md:px-16 lg:px-24">
        <div
          className={`flex items-center justify-between ${
            showSearchInHeader ? 'py-1. 5' : 'py-2'
          } transition-all duration-200 ease-out-cubic`}
        >
          <div className="flex items-center gap-3">
            <a
              href="/"
              className="text-base md:text-lg font-semibold text-primary no-underline hover:underline"
            >
              {pharmacyName}
            </a>
          </div>

          <div className="flex items-center gap-2 pt-1">
            <CartButton />
            {mapsUrl ? (
              <a
                href={mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-1.5"
              >
                <MapPin size={14} className="text-primary" />
              </a>
            ) : (
              <MapPin size={14} className="text-primary ml-1.5" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
